import React from "react";
export const apiEndpoint = process.env.REACT_APP_APIENDPOINT;
export const version = "0.0.1";
export const loggerUrl =
  "https://3c2e0a634d33416ea666cf329f99cbde@o589726.ingest.sentry.io/4504170884562944";
